import { Factory } from 'miragejs'
import { faker } from '@faker-js/faker'

export default Factory.extend({
  schoolSupportEmail() {
    return faker.internet.exampleEmail({ firstName: 'school', lastName: 'support' }) // eg school_support42@example.com
  },

  schoolSupportPhone() {
    return faker.phone.number()
  },

  schoolSupportPhoneHours() {
    return 'Mon - Fri, 9am - 5pm EST. Sat - 10am - 2pm EST.'
  },

  schoolSupportPhoneTollFree() {
    return faker.datatype.boolean()
  },

  schoolSalesEmail() {
    return faker.internet.exampleEmail({ firstName: 'school', lastName: 'sales' })
  },

  schoolSalesPhone() {
    return faker.phone.number()
  },

  schoolSalesPhoneHours() {
    return 'Mon - Fri, 9am - 5pm EST. Sat - 10am - 2pm EST.'
  },

  schoolSalesPhoneTollFree() {
    return faker.datatype.boolean()
  },

  address() {
    return faker.location.streetAddress({ useFullAddress: true })
  },
})
